// Shared section definitions for browse pages (My Checklists + Community
// Checklists). Both pages MUST use the same sectioning so a set can never
// appear in one but not the other.
//
// `match(set)` runs against each loaded set; sets without a section row in
// Supabase fall back to the dataFile heuristic, and anything that matches
// no named section lands in OTHER.

const NAMED_SECTIONS = [
  {
    id: 'chrome-black',
    label: 'CHROME BLACK',
    accent: '#4fc3f7',
    match: s => s.section === 'chrome-black' || (s.dataFile && s.dataFile.includes('chrome-black')),
  },
  {
    id: 'chrome-sw',
    label: 'CHROME STAR WARS',
    accent: '#ff4444',
    match: s => s.section === 'chrome-sw' || (s.dataFile && s.dataFile.includes('chrome-sw')),
  },
  {
    id: 'flagship',
    label: 'STAR WARS FLAGSHIP',
    accent: '#ffb300',
    match: s => s.section === 'flagship' || (s.dataFile && /^\d{4}-star-wars$/.test(s.dataFile)),
  },
  {
    id: 'smugglers-outpost',
    label: "SMUGGLER'S OUTPOST",
    accent: '#d4a855',
    match: s => s.section === 'smugglers-outpost' || (s.dataFile && s.dataFile.includes('smugglers')),
  },
  {
    id: 'hyperspace',
    label: 'HYPERSPACE',
    accent: '#00e87a',
    match: s => s.section === 'hyperspace' || (s.dataFile && s.dataFile.includes('hyperspace')),
  },
  {
    id: 'galaxy',
    label: 'CHROME GALAXY',
    accent: '#00d4ff',
    match: s => s.section === 'galaxy' || (s.dataFile && s.dataFile.includes('galaxy')),
  },
  {
    id: 'sapphire',
    label: 'CHROME SAPPHIRE',
    accent: '#4d9fff',
    match: s => s.section === 'sapphire' || (s.dataFile && s.dataFile.includes('sapphire')),
  },
  {
    id: 'high-tek',
    label: 'HIGH-TEK',
    accent: '#ff4444',
    match: s => s.section === 'high-tek' || (s.dataFile && s.dataFile.includes('high-tek')),
  },
  {
    id: 'finest',
    label: 'FINEST',
    accent: '#2ee6c8',
    match: s => s.section === 'finest' || (s.dataFile && s.dataFile.includes('finest')),
  },
  {
    id: 'masterwork',
    label: 'MASTERWORK',
    accent: '#c9a227',
    match: s => s.section === 'masterwork' || (s.dataFile && s.dataFile.includes('masterwork')),
  },
  {
    id: 'signature-series',
    label: 'SIGNATURE SERIES',
    accent: '#e0e0e8',
    match: s => s.section === 'signature-series' || (s.dataFile && s.dataFile.includes('signature-series')),
  },
  {
    id: 'stellar-signatures',
    label: 'STELLAR SIGNATURES',
    accent: '#b060ff',
    match: s => s.section === 'stellar-signatures' || (s.dataFile && s.dataFile.includes('stellar')),
  },
  {
    id: '1977-series',
    label: '1977 SERIES 1-5',
    accent: '#f0c040',
    match: s => s.section === '1977-series' || (s.dataFile && s.dataFile.includes('1977-series')),
  },
];

// Final SECTIONS list: named ones, then an OTHER fallback that catches any
// published set whose section/dataFile doesn't match any named section. This
// prevents future product lines from being silently hidden from the grid.
export const SECTIONS = [
  ...NAMED_SECTIONS,
  {
    id: 'other',
    label: 'OTHER STAR WARS',
    accent: '#888aa0',
    match: s => !NAMED_SECTIONS.some(sec => sec.match(s)),
  },
];

// Browse order: newest year first, then newest release date within the year,
// so a just-released set leads its year instead of landing wherever the
// Supabase rows happen to come back. Sets with no parseable release date
// (e.g. just "2025") sort after dated ones in their year.
const releaseTime = s => {
  const t = Date.parse(s.releaseDate);
  return Number.isNaN(t) || /^\s*\d{4}\s*$/.test(String(s.releaseDate)) ? -Infinity : t;
};
export const byNewest = (a, b) => (b.year - a.year) || (releaseTime(b) - releaseTime(a)) || 0;
